export default __webpack_public_path__ + "static/media/Grimjaw Helm.b04f2dcd.jpg";